var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import * as React from 'react';
import classnames from 'classnames';
import Icon from '@alife/next-icon';
import When from '../when';
var LoadState;
(function (LoadState) {
    LoadState["loading"] = "loading";
    LoadState["error"] = "error";
    LoadState["success"] = "success";
})(LoadState || (LoadState = {}));
var BackgroundImg = (function (_super) {
    __extends(BackgroundImg, _super);
    function BackgroundImg(props) {
        var _this = _super.call(this, props) || this;
        _this.state = { loadState: LoadState.loading };
        return _this;
    }
    BackgroundImg.prototype.updateLoadState = function (loadState) {
        this.setState({ loadState: loadState });
    };
    BackgroundImg.prototype.componentDidMount = function () {
        this.fetchImage(this.props.src);
    };
    BackgroundImg.prototype.componentWillReceiveProps = function (nextProps) {
        if (this.props.src !== nextProps.src) {
            this.fetchImage(nextProps);
        }
    };
    BackgroundImg.prototype.fetchImage = function (src) {
        var _this = this;
        if (!src) {
            this.updateLoadState(LoadState.error);
            return;
        }
        var image = new Image();
        var onLoad = this.props.onLoad;
        image.onload = function () {
            _this.updateLoadState(LoadState.success);
            onLoad && onLoad(image);
        };
        image.onerror = function () {
            _this.updateLoadState(LoadState.error);
        };
        image.src = src;
    };
    BackgroundImg.prototype.render = function () {
        var _a = this.props, src = _a.src, children = _a.children, className = _a.className, defaultHeight = _a.defaultHeight, defaultWidth = _a.defaultWidth, onClick = _a.onClick, title = _a.title;
        var loadState = this.state.loadState;
        var style = {
            backgroundImage: loadState === LoadState.error || loadState === LoadState.loading ? "" : "url(" + src + ")",
            height: defaultHeight ? defaultHeight + "px" : '',
            width: defaultWidth ? defaultWidth + "px" : ''
        };
        return (React.createElement("div", { style: style, className: classnames('background-default', className, { 'error': loadState === LoadState.error }), onClick: onClick, title: title },
            React.createElement(When, { condition: loadState === LoadState.error },
                React.createElement(Icon, { type: "prompt", className: "load-failed" })),
            React.createElement(When, { condition: loadState === LoadState.loading },
                React.createElement(Icon, { type: "loading" })),
            children));
    };
    BackgroundImg.defaultProps = {
        onLoad: function () { },
        onClick: function () { }
    };
    return BackgroundImg;
}(React.Component));
export default BackgroundImg;

//# sourceMappingURL=index.js.map
